import React, { useEffect } from 'react';
import './SetupStepSparkleBurst.css';

const PARTICLES = [
    { type: 'star', tx: 14, ty: -10, size: 11, color: '#4a3fa8', rotate: -12 },
    { type: 'star', tx: 32, ty: 2, size: 7, color: '#6b5fc7', rotate: 18 },
    { type: 'star', tx: 6, ty: -14, size: 5, color: '#8b7fd4', rotate: 8 },
    { type: 'dot', tx: 22, ty: -6, size: 4, color: '#6b5fc7' },
    { type: 'dot', tx: 4, ty: 4, size: 3, color: '#9b8fd4' },
    { type: 'dot', tx: 38, ty: -8, size: 3, color: '#7c6fd6' },
    { type: 'dot', tx: 18, ty: 8, size: 2.5, color: '#b0a8d8' },
    { type: 'ring', tx: 28, ty: -12, size: 9, color: '#a89fd4' },
    { type: 'dot', tx: 42, ty: 0, size: 2, color: '#c4bddf' },
];

function SparkleStar({ size, color, rotate }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            style={{ transform: `rotate(${rotate}deg)` }}
        >
            <path
                d="M12 3v18M3 12h18"
                stroke={color}
                strokeWidth="3.5"
                strokeLinecap="round"
            />
        </svg>
    );
}

function SetupStepSparkleBurst({ onDone, durationMs = 650 }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            if (onDone) onDone();
        }, durationMs);
        return () => clearTimeout(timer);
    }, [onDone, durationMs]);

    return (
        <span className="setup-step-sparkle-burst" aria-hidden="true">
            {PARTICLES.map((particle, index) => (
                <span
                    key={index}
                    className={`setup-step-sparkle-burst__particle setup-step-sparkle-burst__particle--${particle.type}`}
                    style={{
                        '--tx': `${particle.tx}px`,
                        '--ty': `${particle.ty}px`,
                        '--particle-color': particle.color,
                        '--particle-size': `${particle.size}px`,
                        '--particle-rotate': `${particle.rotate || 0}deg`,
                        animationDelay: `${index * 20}ms`,
                    }}
                >
                    {particle.type === 'star' && (
                        <SparkleStar size={particle.size} color={particle.color} rotate={particle.rotate || 0} />
                    )}
                </span>
            ))}
        </span>
    );
}

export default SetupStepSparkleBurst;
